import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import { BASE_URL } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class UsersService {

    constructor(
        private http: Http,
        private router: Router,
        private toastr: ToastrService
    ) { }

    private loginHeaders = new Headers({ 'Content-Type': 'application/json' });
    private loginOptions = new RequestOptions({ headers: this.loginHeaders });

    //Login & Logout
    login(data) {
        return this.http.post(BASE_URL + 'login', data, this.loginOptions)
            .map((response: Response) => {
                const user = response.json();
                if (user && user.security_token) {
                    localStorage.setItem('securityToken', user.security_token);
                    localStorage.setItem('clientId', user.client_id);
                    localStorage.setItem('userId', user.user_id);
                    localStorage.setItem('username', user.username);
                    localStorage.setItem('roleId', user.role_id);
                    localStorage.setItem('roleName', user.role_name);
                    localStorage.setItem('calendar', 'false');
                }
            });
    }

    logout() {
        return this.http.get(BASE_URL + 'logout', this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                return Observable.throw(err.json());
            });
    }

    autoLogin(data) {
        return this.http.put(BASE_URL + 'auto_login', data, this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                return Observable.throw(err.json());
            });
    }

    //Passwords
    forgotPassword(data) {
        return this.http.put(`${BASE_URL}user/password/reset/email`, data)
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                return Observable.throw(err.json());
            });
    }

    setPassword(id, reg_token, data) {
        return this.http.post(`${BASE_URL}users/${id}/password/reset/${reg_token}`, data)
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                return Observable.throw(err.json());
            });
    }

    changePassword(data) {
        return this.http.put(`${BASE_URL}user/change_password`, data, this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                this._handleError(err);
                return Observable.throw(err.json());
            });
    }

    //Register
    memberRegistration(data) {
        return this.http.put(BASE_URL + 'member/register', data, this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                return Observable.throw(err.json());
            });
    }

    //Register confirm
    sympathizerRegistrationConfirm(id, reg_token) {
        return this.http.get(`${BASE_URL}sympathizer/registration_confirm/${id}/${reg_token}`)
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                return Observable.throw(err.json());
            });
    }

    memberRegistrationConfirm(id, reg_token, data) {
        return this.http.put(`${BASE_URL}member/registration_confirm/${id}/${reg_token}`, data)
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                return Observable.throw(err.json());
            });
    }

    memberPresidentRegistrationConfirm(id, reg_token, data) {
        return this.http.put(`${BASE_URL}member/registration_confirm/${id}/${reg_token}?district_committee_president=True`, data)
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                return Observable.throw(err.json());
            });
    }

    resendRegistrationConfirmationEmailAndSms(id) {
        return this.http.get(`${BASE_URL}registration_confirm/resend/${id}`, this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                return Observable.throw(err.json());
            });
    }

    //Users
    getAllActiveMembers() {
        return this.http.get(BASE_URL + 'get_active_members', this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                this._handleError(err);
                return Observable.throw(err.json());
            });
    }

    getAllSympathizers() {
        return this.http.get(BASE_URL + 'get_sympathizers', this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                this._handleError(err);
                return Observable.throw(err.json());
            });
    }

    getAllInactiveMembers() {
        return this.http.get(BASE_URL + 'get_inactive_members', this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                this._handleError(err);
                return Observable.throw(err.json());
            });
    }

    getAllUnverifiedMembers() {
        return this.http.get(BASE_URL + 'get_unverified_members', this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                this._handleError(err);
                return Observable.throw(err.json());
            });
    }

    getSingleUser(id) {
        return this.http.get(`${BASE_URL}users/${id}`, this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                this._handleError(err);
                return Observable.throw(err.json());
            });
    }

    getUserRegistrationStatus(id) {
        return this.http.get(`${BASE_URL}users/${id}/status`, this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                return Observable.throw(err.json());
            });
    }

    addUser(data) {
        return this.http.post(BASE_URL + 'users/add', data, this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                this._handleError(err);
                return Observable.throw(err.json());
            });
    }

    editProfile(data) {
        return this.http.put(BASE_URL + 'user/edit_profile', data, this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                this._handleError(err);
                return Observable.throw(err.json());
            });
    }

    editUser(id, data) {
        return this.http.post(`${BASE_URL}users/${id}/edit`, data, this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                this._handleError(err);
                return Observable.throw(err.json());
            });
    }

    deleteUser(id) {
        return this.http.delete(`${BASE_URL}users/${id}/delete`, this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                this._handleError(err);
                return Observable.throw(err.json());
            });
    }

    verifyUser(id) {
        return this.http.put(`${BASE_URL}verify_registered_user/${id}`, {}, this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                this._handleError(err);
                return Observable.throw(err.json());
            });
    }

    searchImportedUser(id) {
        return this.http.get(`${BASE_URL}search_imported_user?membership_card_id=${id}`, this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                this._handleError(err);
                return Observable.throw(err.json());
            });
    }

    activateImportedUser(id, data) {
        return this.http.post(`${BASE_URL}activate_imported_user/${id}`, data, this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                this._handleError(err);
                return Observable.throw(err.json());
            });
    }

    activateUser(id, data) {
        return this.http.post(`${BASE_URL}users/${id}/activate`, data, this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                this._handleError(err);
                return Observable.throw(err.json());
            });
    }

    //User roles
    getRoles() {
        return this.http.get(BASE_URL + 'roles', this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                this._handleError(err);
                return Observable.throw(err.json());
            });
    }

    //Districts & towns
    getAllDistricts() {
        return this.http.get(BASE_URL + 'districts', this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                this._handleError(err);
                return Observable.throw(err.json());
            });
    }

    getAllTowns(id) {
        return this.http.get(`${BASE_URL}districts/${id}/towns`, this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                this._handleError(err);
                return Observable.throw(err.json());
            });
    }

    getChildOrganizations(id) {
        return this.http.get(`${BASE_URL}organizations/${id}/child_organizations`, this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                this._handleError(err);
                return Observable.throw(err.json());
            });
    }

    //File upload
    fileUpload(file, id) {
        const data = new FormData();
        data.append('media_file', file);

        return this.http.post(`${BASE_URL}media/upload/${id}`, data, this.getToken())
            .map(res => (<Response>res).json())
            .catch((err: Response) => {
                this._handleError(err);
                return Observable.throw(err.json());
            });
    }

    //Error function
    _handleError(error) {
        console.log(error);
        if (error.status === 401 || error.status === 455 || error.status === 403) {
            const clientObject = { client_id: localStorage.getItem('clientId') };
            if (localStorage.getItem('clientId') !== null) {
                this.autoLogin(clientObject).subscribe(
                    response => {
                        localStorage.setItem('securityToken', response.security_token);
                        localStorage.setItem('clientId', response.client_id);
                        this.toastr.warning('Vaš sigurnosni token je istekao, bit ćete automatski ponovo prijavljeni');
                        setTimeout(() => {
                            location.reload();
                        }, 2000);
                    },
                    err => {
                        console.log(err);
                        if (err.error_msg) {
                            this.toastr.error(err.error_msg);
                            this.router.navigate([`/login`]);
                        }
                    });
            } else {
                this.router.navigate([`/login`]);
            }
        } else {
            return Observable.throw(error.json());
        }
    }

    //Header with token
    private getToken() {
        const token = localStorage.getItem('securityToken');
        if (token) {
            const headers = new Headers({
                'Content-Type': 'application/json',
                'Securitytoken': token,
            });
            return new RequestOptions({ headers: headers });
        }
    }
}



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/services/users/users.service.ts